import './App.css';
import {Component} from "react";
import store from "./Storage";
import {chooseDivision, hoverDivision, loadBattleMap, setDivisionTarget, togglePause} from "./actions";
import {stopSounds} from "./SoundManager";
import {
  DEBUG_SCROLL,
  DEBUG_WIN_FAST,
  MODE_BASE,
  MODE_BATTLE,
  MODE_BATTLE_END,
  MODE_SCRIPT,
  SIDES_ME,
  UNIT_SIZE,
} from "./constants";
import {IMAGES} from "./Images";
import {TEXTS} from "./Texts";
import {RollingText} from "./RollingText";

const getUnitSize = (zoom) => {
  return zoom * UNIT_SIZE
}

function MovementTarget({x, y, zoom, color="orange"}) {
  var unitSize = getUnitSize(zoom)

  return <div
    className={"dots"}
    style={{
      position: 'absolute',
      left: x * unitSize + 'px',
      top: y * unitSize + 'px',
      // color: 'orange',
      color,
      backgroundColor: color,
      borderColor: color,
      // borderWidth: 0,
      // border: 0,
      pointerEvents: 'none'
    }}
  />
  // ·*.
}

function WarriorView({color, zoom, type, imgUrl, x, y, health, isTestWarrior, engaged, onChooseDivision, isChosenDivision, onHoverDivision, divisionId, isHoveredDivision}) {
  var warriorColor = color;

  var isOpponent = color !== "red";

  // var col = isTestWarrior ? 'blue' : (isChosenDivision ? "orange" : color)
  var col = isTestWarrior ? 'blue' : (isChosenDivision ? "orange" : color)
  var borderColor = isChosenDivision ? "orange" : color
  var anim;
  if (engaged) {
    anim = <b style={{color: 'purple'}}>·</b>
  }

  var borderWidth = isChosenDivision ? 1 : 0;
  var uSize = getUnitSize(zoom);

  return <div
    style={Object.assign({
      color: col,
      position: 'absolute',
      left: x * uSize + 'px',
      top:  y * uSize + 'px',
      width: uSize-borderWidth + 'px',
      height: uSize-borderWidth + 'px',
      borderWidth: borderWidth + 'px',
      borderColor,
      borderStyle: 'solid',

      // border: 0,
      // borderRadius: '100%',
      cursor: isOpponent ? 'crosshair' : 'pointer'
    }, {})}
    onClick={isOpponent ? () => {} : onChooseDivision}
    onMouseEnter={() => onHoverDivision(divisionId)}
    onMouseLeave={() => {onHoverDivision(-1)}}
  >
    {anim}
    <img
      alt={""}
      // src={`warrior2-${col}.png`}
      // src={`persian-min.png`}
      src={imgUrl}
      // src={"pngwing.com.png"}
      // width={"100px"}
      // height={"100px"}
      style={{
        width: "100%", height: "100%",
        // color: col
        // filter: `opacity(0.85) drop-shadow(0 0 0 ${col})`,
        pointerEvents: 'none'
      }}
    />
  </div>
}




var pressedKeys = {};
window.onkeyup = function(e) { pressedKeys[e.keyCode] = false; }
window.onkeydown = function(e) { pressedKeys[e.keyCode] = true; }

const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

class BattlePage extends Component {
  state = {
    chosenDivisionId: -1,
    hoveredDivisionId: -1,

    currentTime: 0,

    battleEnded: false,
    battleTimer: -1,

    testWarriorIndex: 0,
    stage: 0,

    knowsHowToMove: false,
    knowsHowToPause: false,
    knowsHowToSelectTroops: false,
    isPaused: true,

    divisions: {},
    warriors: [],
    engaged: {},

    kills: 0,

    empty: [],
    allied: [],
    enemies: [],
    movable: [],
    fighting: [],

    loaded: false,

    zoomY: 1,
    camX: 0,
    camY: 0,
  }

  restart = () => {
    console.log('restart in app.js. loadBattleMap')
    loadBattleMap()
  }

  componentWillUnmount() {
    console.log('UMOUNT')

    document.removeEventListener('contextmenu', this.onMove);
    document.removeEventListener('keydown', this.keyDownHandler);
    document.removeEventListener('keyup', this.keyUpHandler);
    document.removeEventListener('wheel', this.wheelHandler)
  }

  onMove = event => {
    event.preventDefault()

    var size = getUnitSize(this.state.zoomY);
    var {camX, camY} = this.state;

    var dx = camX / UNIT_SIZE + event.clientX / size
    var dy = camY / UNIT_SIZE + event.clientY / size

    setDivisionTarget(dx, dy)
  }


  keyDownHandler = event => {
    // console.log('User pressed: ', event.key);

    pressedKeys[event.key] = true;

    if (event.key === ' ') {
      event.preventDefault();
    }

    // if (event.key === 'K') {
    //
    // }
  };
  keyUpHandler = event => {
    if (event.key === ' ') {
      event.preventDefault()

      if (pressedKeys[event.key]) {
        togglePause()
        pressedKeys[event.key] = false;
      }
    }

    if (event.key === 'b') {
      stopSounds()
    }
  }

  wheelHandler = (event) => {
    event.preventDefault()
    // window.scrollTo(0, 0)

    if (DEBUG_SCROLL) {
      var dY = event.deltaY;

      var zoomY = this.state.zoomY - dY / 500;
      zoomY = clamp(zoomY, 0.2, 1.4)

      this.setState({zoomY})
    }
  }

  componentDidMount() {
    console.log('componentDidMount')



    document.addEventListener('contextmenu', this.onMove);
    document.addEventListener('keydown', this.keyDownHandler);
    document.addEventListener('keyup', this.keyUpHandler);
    document.addEventListener('wheel', this.wheelHandler)

    store.addChangeListener(() => {
      this.updateState()
    })

    this.restart()
  }

  updateState() {
    var tutorialStats = store.getTutorialStats();
    this.setState({
      warriors: store.getWarriors(),
      divisions: store.getDivisions(),
      loaded: store.isLoaded(),
      isPaused: store.isPaused(),
      currentTime: store.getCurrentTime(),
      battleEnded: store.isBattleEnded(),
      stage: store.getStage(),

      fighting: store.getFighting(),

      hoveredDivisionId: store.getHoveredDivisionId(),
      chosenDivisionId: store.getChosenDivisionId(),
      ...tutorialStats
    })
  }

  // TODO store
  getDivisionCount =(divisionId) => store.getDivisionCount(divisionId)
  getDivision = (divisionId) => store.getDivision(divisionId)
  getDivisionCenter = divisionId => store.getDivisionCenter(divisionId)

  renderDivisionEmblems = () => {
    return this.state.divisions.map(d => {
      var center = this.getDivisionCenter(d.divisionId)
      var count = this.getDivisionCount(d.divisionId)

      var color = 'black' // this.state.chosenDivisionId === d.divisionId ? 'orange' : 'white'
      var flag = d.side === SIDES_ME ? IMAGES.sidesGeo : IMAGES.sidesPersians
      // color = d.side === SIDES_ME ? 'red' : 'black'

      var unitSize = getUnitSize(this.state.zoomY);
      return <div
        className={"division-emblem"}
        style={{
          // backgroundColor: d.side,
          left: (center.x * unitSize) + 'px',
          top: (center.y * unitSize) + 'px',
          color,
          borderColor: color,
          backgroundImage: `url(${flag})`
        }}
      >
        {count}
        {/*<img width={'100%'} height={'100%'} src={}/>*/}
        {/*<div style={{color: 'white'}}>*/}
        {/*  {count}*/}
        {/*</div>*/}
      </div>
    })
  }

  getUnitPopup = () => {
    var hoveredTab;
    var hoveredDivision = this.getDivision(this.state.hoveredDivisionId)

    if (!hoveredDivision)
      return null

    if (hoveredDivision) {
      var mouseX = 850;
      var mouseY = 150;

      // hoveredDivisionX
      // hoveredDivisionY

      hoveredTab = <div
        className={"hover-popup"}
        style={{left: mouseX + 'px', top: mouseY + 'px', borderColor: hoveredDivision.side, color: hoveredDivision.side}}
      >
        <h1>{hoveredDivision.name}</h1>
        {/*<h2>{hoveredDivision.commander}</h2>*/}
        <h3>{hoveredDivision.type}</h3>
        <center>
          <table>
            <tr>
              <td><b>{TEXTS.amount}</b></td>
              <td></td>
              <td>{this.getDivisionCount(this.state.hoveredDivisionId)}</td>
            </tr>
            {/*<tr>*/}
            {/*  <td><b>ძალა</b></td>*/}
            {/*  <td>{hoveredDivision.attack}</td>*/}
            {/*</tr>*/}

            {/*<tr>*/}
            {/*  <td>Defence</td>*/}
            {/*  <td>{hoveredDivision.defence}</td>*/}
            {/*</tr>*/}
            {/*<tr>*/}
            {/*  /!*<td>Movable | Enemies</td>*!/*/}
            {/*  <td>Enemies</td>*/}
            {/*  <td>{this.state.enemies.length}<br /><br />{JSON.stringify(this.state.enemies)}</td>*/}
            {/*</tr>*/}
            {/*<tr>*/}
            {/*  <td>Allied | Empty</td>*/}
            {/*  <td>{this.state.allied} | {this.state.empty}</td>*/}
            {/*</tr>*/}

            {/*<tr>*/}
            {/*  <td>Health</td>*/}
            {/*  <td style={{display: "grid", gridTemplateColumns: "auto auto auto auto"}}>*/}
            {/*    {this.getDivisionWarriors(this.state.hoveredDivisionId).map(w => <span>{w.health}</span>)}*/}
            {/*  </td>*/}
            {/*</tr>*/}
          </table>
        </center>
        <br />
        <img src={hoveredDivision.imageUrl} width={200} height={200} />
      </div>
    }

    return hoveredTab
  }

  renderWarriors = () => {
    var armies = []

    this.state.warriors.forEach((w, index) => {
      const divisionId = w.divisionId;
      const c = w;
      const d = this.getDivision(divisionId)

      if (store.isAlive(w)) {
        armies.push(<WarriorView
          divisionId={divisionId}
          onChooseDivision={() => chooseDivision(divisionId)}
          onHoverDivision={hoverDivision}
          isChosenDivision={this.state.chosenDivisionId === divisionId}
          isHoveredDivision={this.state.hoveredDivisionId === divisionId}
          engaged={!!this.state.engaged[index]}
          isTestWarrior={this.state.testWarriorIndex === index}
          imgUrl={d.minImgUrl}
          zoom={this.state.zoomY}

          color={c.color} x={c.x} y={c.y} type={c.type} health={c.health} key={`warrior-${index}`}
        />)
      }
    })

    return armies
  }

  renderTutorial = () => {
    let tutorials;

    const tutorialImage = (src, width=50, height=50) => <img width={width} height={height} src={src} />

    if (!this.state.knowsHowToPause)
      tutorials = <div>კაია, დააჭირე {tutorialImage("space.png", 150, 70)} რო პაუზა მოხსნა</div>
    if (!this.state.knowsHowToMove)
      tutorials = <div>ყოჩაღ, ეხლა დააჭირე {tutorialImage("rmb.png")} ჯარი რომ გატოკდეს</div>
    if (!this.state.knowsHowToSelectTroops)
      tutorials = <div>დააჭირე რომელიმე დივიზიას</div>

    if (tutorials)
      return <div className={"tutorial"}>{tutorials}</div>
    return '';
  }

  renderGoal = (weWon, survivalTime) => {
    var phrase = weWon ? TEXTS.erekleSaved : TEXTS.winTimeForErekle


    const ereklePosition = `calc(100vw * ${this.state.currentTime} / ${survivalTime})`
    const goalMockup = <div className={"goal-container"}>
      <span className={'mission-completed'}>{phrase}</span>

      <img alt={""} width={35} height={'100%'} src={IMAGES.erekleMin} style={{position: 'absolute', zIndex: 100, left: ereklePosition }} />
      <img alt={""} width={65} height={'100%'} src={IMAGES.ananuri} style={{position: 'absolute', right: 0 }} />
    </div>

    return goalMockup
  }
  
  renderMyDivisionIcons = () => {
    const my = store.getMyDivisions()

    // width: "calc(100vw - 250px)"
    return <div
      style={{position: 'fixed', bottom: 0, height: '80px', width: "calc(100vw - 250px)", pointerEvents: 'none'}}>
      <center>
        <table style={{textAlign: 'center', width: "350px", cursor: "pointer", zIndex: -1}}>
          {/*<tr>*/}
          {/*  {my.map(m => <td onClick={() => {this.chooseDivision(m.divisionId)}}>*/}
          {/*    <img alt={""} height={25} width={25} />*/}
          {/*  </td>)}*/}
          {/*</tr>*/}
          <tr>
            {my.map(m => <td style={{color: "white"}} onClick={() => {
              this.chooseDivision(m.divisionId)
            }}>
              {this.getDivisionCount(m.divisionId)}
            </td>)}
          </tr>
          <tr>
            {my.map(m => <td style={{color: this.state.chosenDivisionId === m.divisionId ? "orange" : 'white'}}
                             onClick={() => {
                               this.chooseDivision(m.divisionId)
                             }}>
              <b>{m.name}</b>
            </td>)}
          </tr>
        </table>
      </center>
    </div>
  }

  renderMovementTarget = () => {
    var chosenDivision = this.getDivision(this.state.chosenDivisionId)

    var list = [];
    if (chosenDivision) {
      this.state.warriors.forEach((w, i) => {
        const isChosen = w.divisionId === this.state.chosenDivisionId

        if (store.isAlive(w) && store.isMoving(w) && isChosen)
          list.push(<MovementTarget zoom={this.state.zoomY} color={"red"} key={`target_${this.state.chosenDivisionId}__${i}`} y={w.targetY} x={w.targetX} />)
      })
    }

    return list
  }

  render() {
    if (!this.state.loaded)
      return <div className={"dark-background page-container"}/>


    const survivalTime = DEBUG_WIN_FAST ? 10 : 6 * 60;
    var currentTime = this.state.currentTime;
    var weWon = currentTime >= survivalTime





    if (this.state.battleEnded) {
      if (weWon) {
        return <div className={"dark-background page-container"}>
          <h1 className={'shadow'}>{TEXTS.lostButErekleRunAway}</h1>
          <br />
          <br />
          <center>
            <button className={"to-battle-button accent"} onClick={() => {this.props.onBattleEnd()}}>{TEXTS.quitBtnText}</button>
          </center>
        </div>
      }

      return <div className={"dark-background page-container"}>
        <h1 className={'shadow'}>{TEXTS.failedToSaveErekle}</h1>
        <h3 className={'shadow'}>{TEXTS.failedToSaveErekleAlternativeHistory}</h3>
        <br />
        <br />
        <br />
        <br />
        <center>
          <button className={"to-battle-button accent"} onClick={() => {this.restart()}}>{TEXTS.restart}</button>
          <button className={"to-battle-button"} onClick={() => {this.props.onBattleEnd()}}>{TEXTS.quitBtnText}</button>
        </center>
      </div>
    }

    const mouseDownHandler = (event) => {
      if (event.button === 1) {
        // do something on middle mouse button click
        this.setState({
          dragX: event.screenX,
          dragY: event.screenY,
          middlePressed: true,
        })
      }
    }

    const mouseUpHandler = event => {
      if (event.button === 1) {
        this.setState({
          middlePressed: false
        })
      }
    }

    const onMouseMove = event => {
      if (this.state.middlePressed && DEBUG_SCROLL) {
        var diffX = event.screenX - this.state.dragX
        var diffY = event.screenY - this.state.dragY

        var camX = this.state.camX + diffX;
        var camY = this.state.camY + diffY;

        this.setState({
          camX, camY,
          dragX: event.screenX,
          dragY: event.screenY,
          middlePressed: true
        })
      }
    }

    var chosenDivision = this.getDivision(this.state.chosenDivisionId)
    var chosenDivisionWarriors = store.getDivisionWarriors(this.state.chosenDivisionId)
    var testWarrior = chosenDivisionWarriors.length ? chosenDivisionWarriors[0] : {targetX: -1000, targetY: -1000}

    const onDevMachine = window.location.href.includes("localhost")

    return <div className={"battle-container"}>
      <div
        style={{position: 'relative', minHeight: '100vh', overflow: 'hidden'}}
        onMouseDown={mouseDownHandler}
        onMouseUp={mouseUpHandler}
        onMouseMove={onMouseMove}
      >
        <div style={{position: 'absolute', left: this.state.camX + 'px', top: this.state.camY + 'px'}}>
          <div style={{position: 'relative'}}>
            {this.renderWarriors()}
            {this.renderMovementTarget()}
            {this.renderDivisionEmblems()}
          </div>
        </div>


        {/*{this.state.enemies.map(m => <MovementTarget x={m.x} y={m.y} color={"white"} />)}*/}
        {/*{this.state.fighting.map(m => <MovementTarget x={m.x} y={m.y} color={"yellow"} />)}*/}
        {/*{this.state.allied.map(m => <MovementTarget x={m.x} y={m.y} color={"blue"} />)}*/}

        {this.renderTutorial()}
        <div style={{display: onDevMachine ? 'block' : 'none', pointerEvents: 'none', color: 'white', position: 'fixed', top: '120px', left: '5px'}}>
          <div>Zoom: {this.state.zoomY}</div>
          <div>Cam: {this.state.camX}, {this.state.camY}</div>
          <div>Target: {testWarrior?.targetX}, {testWarrior?.targetY}</div>
          <div>STAGE: {this.state.stage}, ended: {this.state.battleEnded}</div>
        </div>
        {this.renderGoal(weWon, survivalTime)}
        {this.getUnitPopup()}
        {/*{this.renderMyDivisionIcons()}*/}
      </div>

      {/*<div className={"unit-popup"} style={{float: 'left', minHeight: '100vh'}}>*/}
      {/*  {hoveredTab}*/}
      {/*</div>*/}
    </div>
  }
}






class PostBattlePage extends Component {
  state = {
    onThanksPage: false,

    battleConcessionsEnded: false,
    thankForPlayingEnded: false,
  }

  onBattleConcessionsTextEnd() {
    this.setState({battleConcessionsEnded: true})
  }
  onThanksForPlayingEnd() {
    this.setState({thankForPlayingEnded: true})
  }

  getButtonToThanksPage() {
    var b;

    if (this.state.battleConcessionsEnded)
      b = <button className={"to-battle-button accent"} onClick={() => {this.setState({onThanksPage: true, count: 0})}}>{TEXTS.next}</button>

    return b
  }

  getButtonToMoreGames() {
    var bb;
    if (this.state.thankForPlayingEnded) {
      bb = <div>
        <h2>{TEXTS.wannaSeeMoreGames}</h2>
        <br />
        <br />
        <center>
          <a href={"https://www.facebook.com/groups/884273320019453"} target={"_blank"}>
            <div className={"to-battle-button accent"}>FB</div>
          </a>
        </center>
      </div>
    }

    return bb
  }

  render() {
    const battleConcessions = <div className="history-text">
      <h1>{TEXTS.aragveliansDiedAll}</h1>
      <div className="history-text">
        <RollingText text={TEXTS.battleEndText} onEnd={this.onBattleConcessionsTextEnd.bind(this)} />
      </div>
      <br />
      <br />
      <br />
      {this.getButtonToThanksPage()}
    </div>

    const thanksForPlayingText = <div className="history-text">
      <h1>{TEXTS.thanksForPlayingMyGame}</h1>
      <RollingText text={TEXTS.thanksText} onEnd={this.onThanksForPlayingEnd.bind(this)} />
      {this.getButtonToMoreGames()}
    </div>

    return <div className={"dark-background page-container"}>
      <br />
      <br />
      {this.state.onThanksPage ? thanksForPlayingText : battleConcessions}
    </div>
  }
}


class HistoryPage extends Component {
  state = {
    isCanStartFight: false,
  }

  getToBattleButton() {
    var b;
    if (this.state.isCanStartFight)
      b = <button className={"to-battle-button accent"} onClick={this.props.onBattle}>{TEXTS.startBattle}</button>

    return b;
  }

  render() {
    return <div className={"dark-background page-container"}>
      <br />
      <br />
      <div className="history-text">
        <RollingText text={TEXTS.aragvelianPreStory} onEnd={() => {this.setState({isCanStartFight: true})}} />
      </div>

      <br />
      <br />
      <br />
      {this.getToBattleButton()}
    </div>
  }
}



class App extends Component {
  // document.addEventListener('contextmenu', event => {
  //   event.preventDefault()
  // });

  state = {
    mode: MODE_BASE,
    result: false,
  }

  setMode = mode => () => {
    this.setState({mode})
  }

  render() {
    var content;

    switch (this.state.mode) {
      case MODE_SCRIPT:
        content = <HistoryPage  onBattle={this.setMode(MODE_BATTLE)}   />;
        break;
      case MODE_BATTLE:
        content = <BattlePage onBattleEnd={this.setMode(MODE_BATTLE_END)} />;
        break;
      case MODE_BATTLE_END:
        content = <PostBattlePage />;
        break;
    }

    return (
      <div className="App" /*onContextMenu="return false;"*/>
        {/*<header className="App-header">*/}
        {/*</header>*/}
        {content}
      </div>
    );
  }

}

export default App;
